<template>
  <div class="card" v-if="hasAccess">
    <div class="card-header">
      <div class="row">
        <div class="input-group col-sm-3">
          <div class="input-group-prepend custom">
            <div class="input-group-text">
              <span>عنوان سمت</span>
            </div>
          </div>
          <input
            ref="accessTitle"
            v-model="accessTitle"
            :readonly="mode==='view'"
            type="text"
            class="form-control"
          >
        </div>
        <div class="col-sm-9 d-flex justify-content-end">
          <button type="button" class="close" aria-label="Close" @click="goBack">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
      </div>
    </div>
    <div class="card-body">
      <div class="row">
        <div class="col-sm-12">
          <vs-table v-if="show" :params="params" :options="options"></vs-table>
        </div>
      </div>
    </div>
    <div class="card-footer">
      <div class="row mb-2">
        <div class="input-group col-sm-9"></div>
        <div class="col-sm-2">
          <button v-if="mode!=='view'" class="btn btn-success" @click="submit">
            <span v-if="mode==='create'">ثبت دسترسی</span>
            <span v-if="mode==='edit'">ویرایش دسترسی</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VsTable from "../_framework/VsTable.vue";
import VsSelect from "../_framework/VsSelect.vue";
import ClientSelect from "../components/ClientSelect.vue";
import Vue from "vue";
import EventBus from "../_framework/bus.js";
import { mapState, mapMutations, mapActions } from "vuex";
import BaseService from "../_framework/api/BaseService.js";
import Utils from "../_framework/utils/Utils.js";
import utils from "../components/vue-persian-datetime-picker/modules/utils";
import MultiCheckboxes from "../components/MultiCheckboxes.vue";

export default {
  name: "user-access",
  components: {
    VsTable,
    VsSelect,
    MultiCheckboxes
  },
  data() {
    return {
      hasAccess: true,
      access: {},
      show: true,
      accessTitle: "",
      accessId: "",
      mode: "create",
      userRoutes: [],
      selectableRoutes: [],
      params: {
        list: [],
        headers: {
          id: {
            title: "ردیف",
            type: "number",
            grow: 0.5,
            inHeader: false,
            mode: "view"
          },
          page: {
            title: "صفحه",
            type: "custom",
            component: ClientSelect,
            multiple: false,
            label: "persianName",
            inHeader: true,
            data: this.selectableRoutes,
            flex: 1,
            grow: 1.5,
            rowAlignment: "center"
          },
          accesses: {
            title: "سطح دسترسی",
            type: "custom",
            component: MultiCheckboxes,
            label: "title",
            grow: 2,
            rowAlignment: "center",
            data: [
              { title: "افزودن", value: "add" },
              { title: "خواندن", value: "read" },
              { title: "ویرایش", value: "edit" },
              { title: "حذف", value: "delete" }
            ]
          }
        }
      },
      options: {
        dataSourceType: "store",
        hasActions: true,
        hasActionsInHeader: true,
        headerActionsMode: "create",
        deleteEntityAction: "reset",
        beforeCreateEntity: input => {
          if (!input.page) {
            this.$noty.error("لطفا صفحه مورد نظر را انتخاب نمائید");
            return null;
          }
          if (input.accesses.length < 1) {
            this.$noty.error("لطفا سطح دسترسی را تعیین نمائید");
            return null;
          }
          this.insertRow(input);
          return;
        },
        beforeUpdateEntity: input => {
          if (!input.page) {
            this.$noty.error("لطفا صفحه مورد نظر را انتخاب نمائید");
            return null;
          }
          if (input.accesses.length < 1) {
            this.$noty.error("لطفا سطح دسترسی را تعیین نمائید");
            return null;
          }
          this.updateRow(input);
          input["page"] = input.page;

          this.show = false;
          setTimeout(() => {
            this.show = true;
          }, 200);

          return input;
        },
        beforeFetchEntityList: input => {
          let list = [];
          this.vsTableFeed.map(tf => {
            if (tf.page !== "denied") {
              list.push(tf);
            }
          });
          this.$store.commit("REMOVE_ALL_ROWS_FROM_VS_TABLE_FEED");
          this.$store.commit("RESET_VS_TABLE_FEED", list);
        },
        beforeDeleteEntity: input => {
          this.deleteRow(input.id);
          return null;
        }
      }
    };
  },
  beforeMount() {
    this.options.access = checkAccess(this.$route.path);
    this.hasAccess = !!this.options.access;
  },
  mounted() {
    if (this.$route.query.mode) {
      this.mode = this.$route.query.mode;
    }
    if (this.mode === "view") {
      this.options.hasActionsInHeader = false;
      this.options.hasActions = false;
    } else {
      this.calcRoutes(); // all app routes
      this.options.hasActionsInHeader = true;
      this.options.hasActions = true;
    }
    if (this.$route.query.id) {
      new BaseService("access")
        .getById(this.$route.query.id)
        .then(rs => {
          this.$store.commit("REMOVE_ALL_ROWS_FROM_VS_TABLE_FEED");
          this.accessTitle = rs.data.name;
          this.accessId = rs.data.id;
          rs.data.pageAccesses.map(pa => {
            if (pa.page.controlName !== "denied") {
              let accesses = [];
              if (pa.add) {
                accesses.push({ title: "افزودن", value: "add" });
              }
              if (pa.read) {
                accesses.push({ title: "خواندن", value: "read" });
              }
              if (pa.edit) {
                accesses.push({ title: "ویرایش", value: "edit" });
              }
              if (pa.delete) {
                accesses.push({ title: "حذف", value: "delete" });
              }
              this.insertRow({
                accesses: accesses,
                page: {
                  id: pa.page.id,
                  persianName: pa.page.persianName,
                  path: pa.page.url,
                  controlName: pa.page.controlName
                }
              });
            }
          });
        })
        .catch(error => {});
    }
  },
  methods: {
    goBack() {
      this.$router.push({ name: "سمت ها" });
    },
    calcRoutes(routesArray) {
      this.show = false;
      new BaseService("access/getpages").getList().then(rs => {
        this.selectableRoutes = rs.data;
        this.params.headers.page.data = rs.data;
        this.show = true;
      });
    },
    insertRow(data) {
      this.$store.commit("ADD_ROW_TO_VS_TABLE_FEED", {
        page: data.page.persianName,
        accesses: data.accesses,
        id: data.id
      });
      this.userRoutes.push({
        page: data.page,
        accesses: data.accesses,
        id: data.id
      });
      this.refreshTable();
    },
    updateRow(data) {
      this.userRoutes = this.userRoutes.map(ua => {
        if (ua.id === data.id) {
          ua.page = data.page;
          ua.accesses = data.accesses;
        }
        return ua;
      });
    },
    deleteRow(id) {
      this.userRoutes = this.userRoutes.filter(ua => {
        return ua.id !== id;
      });
      this.$store.commit("DELETE_ROW_FROM_VS_TABLE_FEED", id);
      this.refreshTable();
    },
    refreshTable() {
      let id = 0;
      this.vsTableFeed.map(ur => {
        id = id + 1;
        ur.id = id;
      });
      id = 0;
      this.userRoutes.map(ur => {
        id = id + 1;
        ur.id = id;
      });
      this.show = false;
      setTimeout(() => {
        this.show = true;
      }, 50);
    },
    submit() {
      let model = {
        id: this.mode === "create" ? null : this.accessId,
        name: this.accessTitle,
        pageAccesses: []
      };
      this.userRoutes.map(a => {

        model.pageAccesses.push({

          pageId: a.page.id,
          add: !!a.accesses.find(a => {
            return a.value === "add";
          }),
          read: !!a.accesses.find(a => {
            return a.value === "read";
          }),
          edit: !!a.accesses.find(a => {
            return a.value === "edit";
          }),
          delete: !!a.accesses.find(a => {
            return a.value === "delete";
          })
        });
      });

      if (this.mode === "create") {
        this.createUserAccess(model);
      } else {
        this.updateUserAccess(model);
      }
    },
    createUserAccess(model) {
      new BaseService("access").create(model).then(rs => {
        this.goBack();
      });
    },
    updateUserAccess(model) {

      new BaseService("access").update(model).then(rs => {
        this.goBack();
      });
    }
  },

  computed: {
    ...mapState(["vsTableFeed", "tableRowIndex"])
  }
};
</script>
